import * as React from 'react'

export const useForceUpdateComponent = () => {
  const [count, setCount] = React.useState(0)

  return () => setCount(e => count + 1)
}
